module.exports = "/dist/images/6e5d6096c02e8c18ad95d40ae5bf0089-loader.gif";